<template>
  <el-container>
    <el-main>
      <el-dialog :title="$t('apartmentList.chooseType')" :modal-append-to-body="false" :lock-scroll="false" :visible.sync="dialogVisible" width="460px" style="margin-top:10%;">
          <div style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" id="0" icon="el-icon-office-building" @click="addApartment($event)">{{$t('update.fsxApartment')}}</el-button>
          <el-button type="primary" id="1" icon="el-icon-school" @click="addApartment($event)">{{$t('update.jzxApartment')}}</el-button>
          </div>
      </el-dialog>
      <el-form :inline="true" :model="formApartment" class="demo-form-inline">
        <!-- <el-form-item>
          <el-dropdown>
            <i class="el-icon-setting" style="margin-right: 15px"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>查看</el-dropdown-item>
              <el-dropdown-item>新增</el-dropdown-item>
              <el-dropdown-item>删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>-->
        <el-form-item :label="$t('apartmentList.apartmentName')">
          <el-input v-model="formApartment.apartmentName" style="width:150px" :placeholder="$t('apartmentList.apartmentName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('apartmentList.area')">
        <el-input style="width:180px" v-show="language=='en'" v-model="formApartment.province" :placeholder="$t('addApartmentFSS.province')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="formApartment.province"
          clearable
          @change="getProvinceValue"
          style="width:140px"
          :placeholder="$t('apartmentList.province')"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.provinceList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-input style="width:180px" v-show="language=='en'" v-model="formApartment.city" :placeholder="$t('addApartmentFSS.city')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="formApartment.city"
          clearable
          @change="getCityValue"
          style="width:140px"
          :placeholder="$t('apartmentList.city')"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.cityList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
       </el-select>
       <el-input style="width:180px" v-show="language=='en'" v-model="formApartment.area" :placeholder="$t('addApartmentFSS.area-county')"></el-input>
       <el-select
          v-show="language=='zh'"
          v-model="formApartment.area"
          clearable
          :placeholder="$t('apartmentList.area-county')"
          style="width:140px"
          prop="area"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.areaList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button @click="select" type="primary" icon="el-icon-search">{{$t('apartmentList.qurey')}}</el-button>
            <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">{{$t('apartmentList.addRoom')}}</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
      <template>
        <!-- <el-button type="primary" @click="addApartment">增加公寓</el-button>
        <el-button type="primary" @click="addRoomType">增加房型</el-button>-->
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          empty-text="No Data"
          style="margin-top:5px"
          border
        >
          <el-table-column type="index" :label="$t('apartmentList.number')" width="100" align="center"></el-table-column>
          <el-table-column prop="apartmentName" :label="$t('apartmentList.apartmentName')" align="center"></el-table-column>
          <el-table-column prop="apartmentType" :formatter="this.$util.apartmentTypeFormat" :label="$t('apartmentList.apartmentType')" align="center"></el-table-column>
          <el-table-column prop="linkerType" :label="$t('apartmentList.relation')" align="center">
             <template slot-scope="scope">
               {{scope.row.linkerType==1?$t('apartmentList.apartmentButler'):scope.row.linkerType==2?$t('update.tenantAdmin'):$t('apartmentList.apartmentOwner')}}
             </template>  
          </el-table-column>
          <el-table-column prop="province" :label="$t('apartmentList.province')" align="center"></el-table-column>
          <el-table-column prop="city" :label="$t('apartmentList.city')" align="center"></el-table-column>
          <el-table-column prop="area" :label="$t('apartmentList.area-county')" align="center"></el-table-column>
          <el-table-column prop :label="$t('apartmentList.operate')" width="150" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" :title="$t('apartmentList.detail')" @click="handleEdit(scope.$index, scope.row)">{{$t('tenant.edit')}}</el-button>
              <!-- <el-button type="primary" size="mini" icon="el-icon-edit" title="删除" @click="handleDelete(scope.$index, scope.row)"></el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-main>
    <el-footer>
      <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
      </div>
    </el-footer>
  </el-container>
  <!-- 分页 -->
</template>

<style lang="scss">
</style>
 
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "apartmentList", //这个LoginName最好和引入的vue的LoginName相同
  props: ["tabIndex"],
  data() {
    return {
      language:localStorage.getItem("language"),
      dialogVisible: false,
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      tableData: [],
      formApartment: {
        apartmentName:"",
        province: "",
        city: "",
        area: ""
      }
    };
  },
  components: {
    Pagings
  },
  watch:{
     tabIndex(val) {//监听是否切换到1
       if(val==1){
         this.power();
       }
     } 
  },
  created() {
    this.$store.commit("province", {}); //加载省份
    this.power();
  },
  methods: {
    addApartment(e){
       var btnType=e.currentTarget.id;
       this.dialogVisible=false;
       var data={};
       if(btnType=="0"){
          data.tabName=this.$t("apartmentList.add-fss");
          data.id="fss";
          data.comp="addApartmentFSS";
       }else{
          data.tabName=this.$t("apartmentList.add-jzs");
          data.id="jzs";
          data.comp="addApartmentJZS";
       }
       this.$main.addApartmentTab(data);
    },
    select() {
       this.power();
    },
    getCityValue(val) {
      this.$store.commit("area", { cityCode: val }); //加载区（县）
      this.formApartment.area = "";
    },
    getProvinceValue(val) {
      this.$store.commit("city", { provinceCode: val }); //加载城市
      this.formApartment.city = "";
      this.formApartment.area = "";
    },
    handleEdit(index, row) {
      this.$main.addTab(row);
    },
    power() {
      var formData = new FormData();
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      if(this.formApartment.apartmentName!=""&&this.formApartment.apartmentName!=""){
         formData.append("apartmentName", this.formApartment.apartmentName);
      }
      if(this.formApartment.province!=""&&this.formApartment.province!=""){
         formData.append("province", this.formApartment.province);
      }
      if(this.formApartment.city!=""&&this.formApartment.city!=""){
         formData.append("city", this.formApartment.city);
      }
      if(this.formApartment.area!=""&&this.formApartment.area!=""){
         formData.append("area", this.formApartment.area);
      }
      this.$server
        .exam("/customer/apartment/listApartment", formData)
        .then(data => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/apartment/apartmentList.vue